import { EditBlockSliderInput } from '@components/EditBuildingBlocks/all'
import genericContentItemEditor from '@components/mixins/genericContentItemEditor'

export default {
  name: 'SpacerEditorComponent',
  mixins: [genericContentItemEditor],
  components: {
    'edit-block-slider-input': EditBlockSliderInput,
  },
  data() {
    return {}
  },
  computed: {
    spacerPadding: {
      get() {
        // Removes 'px' from string
        return parseInt(this.component.styling.padding, 10)
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['padding'],
          data: value + 'px',
        })
      },
    },
  },
}
